package com.mgacreative.hotelru.core.network

import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.createSupabaseClient
import io.github.jan.supabase.auth.Auth
import io.github.jan.supabase.postgrest.Postgrest
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

import io.github.jan.supabase.realtime.Realtime

object NetworkConstants {
    const val SUPABASE_URL = "https://hotelos.axileto.com"
    const val SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzAwMDAwMDAwLCJleHAiOjIxMDAwMDAwMDB9.VqDYm6AZPEdgPL299nixa0QPKoLQNVYssN79r9sJ1V0"
}

class SupabaseNetworkClient {
    
    private val _networkErrors = MutableSharedFlow<Throwable>()
    val networkErrors = _networkErrors.asSharedFlow()

    val client: SupabaseClient by lazy {
        try {
            createSupabaseClient(
                supabaseUrl = NetworkConstants.SUPABASE_URL,
                supabaseKey = NetworkConstants.SUPABASE_ANON_KEY
            ) {
                install(Auth) {
                    alwaysAutoRefresh = true
                }
                install(Postgrest)
                install(Realtime)
            }
        } catch (e: Throwable) {
            createSupabaseClient(
                supabaseUrl = NetworkConstants.SUPABASE_URL,
                supabaseKey = NetworkConstants.SUPABASE_ANON_KEY
            ) {
                install(Postgrest)
                install(Realtime)
            }
        }
    }
    
    suspend fun handleError(error: Throwable) {
        _networkErrors.emit(error)
    }
}

